import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { addTeamToFeatureFlag } from "./schema/add-team-to-feature-flag";
import { downloadInsightReport } from "./schema/analytics/download-insight-report";
import { getAnalyticsInsightReports } from "./schema/analytics/get-analytics-insight-reports";
import { getProductInsights } from "./schema/analytics/get-product-insights";
import { getProductsBasicInfo } from "./schema/analytics/get-products-basic-info";
import { getReturnsInsightInfo } from "./schema/analytics/get-returns-insight-info";
import { provideInsightReportFeedback } from "./schema/analytics/provide-insight-report-feedback";
import { checkSession } from "./schema/check-session";
import { deleteRole } from "./schema/delete-role";
import { getCurrentIncidents } from "./schema/get-current-incidents";
import { getEnabledPlatforms } from "./schema/get-enabled-platforms";
import { getFeatureFlag } from "./schema/get-feature-flag";
import { getSandboxLoginConfig } from "./schema/get-sandbox-login-config";
import { getTeamUsers } from "./schema/get-team-users";
import { getUserFeatureFlag } from "./schema/get-user-feature-flag";
import { getUserOnboarding } from "./schema/get-user-onboarding";
import { getUserPermissions } from "./schema/get-user-permissions";
import { getUserRolesOnTeam } from "./schema/get-user-roles-on-team";
import { deferMerchantSetupGuide } from "./schema/merchant-setup/defer-merchant-setup-guide";
import { dismissMerchantSetupGuide } from "./schema/merchant-setup/dismiss-merchant-setup-guide";
import { dismissMerchantSetupTask } from "./schema/merchant-setup/dismiss-merchant-setup-task";
import { getMerchantSetupProgressForTeam } from "./schema/merchant-setup/get-merchant-setup-progress-for-team";
import { markMerchantSetupTaskComplete } from "./schema/merchant-setup/mark-merchant-setup-task-complete";
import { recordMerchantSetupIntakeStep } from "./schema/merchant-setup/record-merchant-setup-intake-step";
import { recordMerchantSetupTaskVisited } from "./schema/merchant-setup/record-merchant-setup-task-visited";
import { setMerchantSetupGuideCompletion } from "./schema/merchant-setup/set-merchant-setup-guide-completion";
import { startMerchantSetupProgress } from "./schema/merchant-setup/start-merchant-setup-progress";
import { submitMerchantSetupIntake } from "./schema/merchant-setup/submit-merchant-setup-intake";
import { removeTeamFromFeatureFlag } from "./schema/remove-team-from-feature-flag";
import { setSandboxPassword } from "./schema/set-sandbox-password";
import { submitMerchantFeedback } from "./schema/submit-merchant-feedback";
import { submitMerchantFeedbackFollowUp } from "./schema/submit-merchant-feedback-follow-up";
import { upsertUserOnboarding } from "./schema/upsert-user-onboarding";
import { upsertUserRole } from "./schema/upsert-user-role";

export const rpcDefinition = {
  addTeamToFeatureFlag,
  checkSession,
  deleteRole,
  getCurrentIncidents,
  getFeatureFlag,
  getTeamUsers,
  getUserFeatureFlag,
  getUserOnboarding,
  getUserPermissions,
  getUserRolesOnTeam,
  getEnabledPlatforms,
  getSandboxLoginConfig,
  removeTeamFromFeatureFlag,
  setSandboxPassword,
  submitMerchantFeedback,
  submitMerchantFeedbackFollowUp,
  upsertUserOnboarding,
  upsertUserRole,
  getAnalyticsInsightReports,
  downloadInsightReport,
  provideInsightReportFeedback,
  getProductInsights,
  getReturnsInsightInfo,
  getProductsBasicInfo,
  getMerchantSetupProgressForTeam,
  startMerchantSetupProgress,
  submitMerchantSetupIntake,
  recordMerchantSetupIntakeStep,
  recordMerchantSetupTaskVisited,
  markMerchantSetupTaskComplete,
  dismissMerchantSetupTask,
  setMerchantSetupGuideCompletion,
  dismissMerchantSetupGuide,
  deferMerchantSetupGuide,
};

export type RedoPlatformRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
